<template>
  <v-dialog
    :value="showDialog"
    @input="close()"
    width="600"
    @keydown.esc="close()"
  >
    <v-card id="pendingApproval" flat>
      <v-app-bar dark flat tabs color="primary">
        <v-btn icon dark @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ resx.labels.approvalPending }}</v-toolbar-title>
        <v-tabs
          slot="extension"
          color="primary"
          centered
          grow
          v-model="selectedTab"
        >
          <v-tab href="#obligation">
            {{ resx.labels.obligation }}
          </v-tab>
          <v-tab href="#contractor">
            {{ resx.labels.contractor }}
          </v-tab>
          <v-tab href="#vehicle" v-if="vehicle">
            {{ resx.labels.vehicle }}
          </v-tab>
        </v-tabs>
      </v-app-bar>
      <v-tabs-items v-model="selectedTab">
        <v-tab-item :value="'obligation'">
          <v-list two-line>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{
                  value && value.data.obligation.name
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  resx.labels.name
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{
                  value && resx.labels[value.data.obligation.type]
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  resx.labels.type
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{
                  value && resx.labels[value.data.obligation.dueDateType]
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  resx.labels.dueDateType
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="value && value.data.obligation.dueDateType == 'monthly'"
            >
              <v-list-item-content>
                <v-list-item-title>{{
                  value && value.data.obligation.dayOfMonth
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  resx.labels.dayOfMonth
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-tab-item>
        <v-tab-item :value="'contractor'">
          <v-list two-line>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{
                  value && value.data.contractorCompany.contractor.name
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  resx.labels.name
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{
                  value && value.data.contractorCompany.type.name
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  resx.labels.type
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{
                  value &&
                    `${value.data.contractorCompany.contractor.identifier.type.toUpperCase()}: ${
                      value.data.contractorCompany.contractor.identifier.number
                    }`
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  resx.labels.identifier
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-tab-item>
        <v-tab-item :value="'vehicle'" v-if="vehicle">
          <v-list two-line>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ vehicle.description }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  resx.labels.description
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ vehicle.type.name }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  resx.labels.type
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{
                  vehicle.uniqueIdentifier
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  resx.labels.domain
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-tab-item>
      </v-tabs-items>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" flat @click="close()">
          {{ resx.labels.close }}
        </v-btn>
        <v-btn color="error" @click="save('cancel')">
          {{ resx.labels.reject }}
        </v-btn>
        <v-btn color="success" @click="save('approve')">
          {{ resx.labels.approve }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
"use script";

import { EventBus } from "@/bus";

import contractorService from "@/services/ContractorCompanyService";

export default {
  name: "pendingObligation",
  computed: {
    vehicle() {
      const self = this;
      const vehicle =
        self.value &&
        self.value.data.contractorCompany.vehicles.find(
          v => v._id == self.value.data.obligation.referenceId
        );
      return vehicle;
    }
  },
  data() {
    return {
      selectedTab: "obligation",
      showDialog: false
    };
  },
  methods: {
    close() {
      this.showDialog = false;
      this.$emit("close");
    },
    async save(action) {
      const result = await contractorService.obligationAuth(
        this.value.data.contractorCompany._id,
        this.value.data.obligation._id,
        action
      );
      this.$store.commit("substractPendingApprovals", this.value._id);
      this.showDialog = false;
      this.$emit(action);
      EventBus.$emit("pendingApprovalObligation", { result });
    }
  },
  props: {
    value: { type: Object }
  },
  watch: {
    value: {
      handler: function(val) {
        this.showDialog = val != null;
        if (val) {
          this.selectedTab = "obligation";
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
#pendingApproval {
  .v-tabs__items {
    min-height: 304px;
  }
}
</style>
